import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SHOW_SPINNER,
  HIDE_SPINNER,
} from './types';
import { showErrorAlert } from './alert.action';
import { AuthenticateService } from './../services';
import { history } from '../helpers';

export const login = (username, password) => {
  return (dispatch) => {
    dispatch({type: SHOW_SPINNER});
    AuthenticateService.login(username, password)
      .then(response => {
        if (response.status === 200) {
          dispatch({type: HIDE_SPINNER});
          dispatch({
            type: LOGIN_SUCCESS,
            data: response.data
          });
          localStorage.setItem('user', JSON.stringify(response.data));
          history.push('/');
        } else {        
          dispatch({type: HIDE_SPINNER});
          showErrorAlert(dispatch, 'Failed operation');
        }
      })
      .catch((error) => {
        dispatch({type: HIDE_SPINNER});
        dispatch({
          type: LOGIN_FAILURE,
          data: (error.response.data) || ''
        });
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    dispatch({type: LOGOUT});
    localStorage.removeItem('user');
  };
};